module.exports = __webpack_public_path__ + "img/background.69e4320f.jpg";